module.exports = __webpack_public_path__ + "media/images/lb/863-c6eda13f93230a72cf39c217d7e88aad.svg";